import { render, staticRenderFns } from "./PeixesAquarioInstitucional.vue?vue&type=template&id=ff79a3e0&"
import script from "./PeixesAquarioInstitucional.vue?vue&type=script&lang=js&"
export * from "./PeixesAquarioInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports